function injectStyle (context) {
  require("!!vue-loader/node_modules/vue-style-loader!css-loader?minimize!../../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/style-compiler/index?{\"optionsId\":\"0\",\"vue\":true,\"id\":\"data-v-cf865cd8\",\"scoped\":true,\"sourceMap\":false}!../../../../../../node_modules/_vux-loader@1.2.9@vux-loader/src/style-loader.js!../../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/selector?type=styles&index=0!./alterDetail.vue")
}
/* script */
export * from "!!babel-loader!../../../../../../node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!../../../../../../node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!../../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/selector?type=script&index=0!./alterDetail.vue"
import __vue_script__ from "!!babel-loader!../../../../../../node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!../../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/selector?type=script&index=0!./alterDetail.vue"
/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-cf865cd8\",\"hasScoped\":true,\"optionsId\":\"0\",\"buble\":{\"transforms\":{}}}!../../../../../../node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!../../../../../../node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!../../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/selector?type=template&index=0!./alterDetail.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cf865cd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports
